import { render, staticRenderFns } from "./CmgCheckoutOrderPickupPreference.vue?vue&type=template&id=581d4f2a&scoped=true&lang=pug"
import script from "./cmg-checkout-order-pickup-preference.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-order-pickup-preference.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutOrderPickupPreference.vue?vue&type=style&index=0&id=581d4f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d4f2a",
  null
  
)

export default component.exports